// angular
import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

// multi-asset
import * as CubiqTS from "shared/cubiq-model-multi-asset";
// global services

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { BfxRBACService } from "app/bfx-common/services/bfx-rbac.service";
import { BfxUserProfileService } from "app/bfx-common/services/bfx-user-profile.service";
import { ScratchPadDataActionPrimaryService } from "../../../../shared/cubiq-services/action/impl/ScratchPadDataActionPrimaryService";
import { ScratchPadDataPrimaryLookupService } from "../../../../shared/cubiq-services/lookup/model/impl/ScratchPadDataPrimaryLookupService";
// cubiq-services
import {
  OrderDataActionPromiseService,
  OrderDataPromiseLookupService,
  InterventionDataPromiseLookupService,
  OrderAcceptancePromiseService,
  OrderSalesApprovalRequestPromiseService,
  TraderGroupPromiseLookupService,
  ProfilePromiseActionService,
  DetailedOrderStatusRequestPromiseService,
  SalesGroupPromiseLookupService,
} from "shared/cubiq-services";
// pipes
import { CapitalizePipe } from "app/bfx-shared/pipes/bfx-capitalize.pipe";
// interface-components models
// order-entry services
import { OEUtilityService } from "../basic/oe-utility.service";
import { OETimeMachineService } from "../basic/oe-time-machine.service";
import { OECoordinatorService } from "../oe-coordinator.service";
import { OEModelGetterService } from "../model/oe-model-getter.service";
import { OEModelSetterService } from "../model/oe-model-setter.service";
import { OEToleranceService } from "../basic/oe-tolerance.service";
import { OEModelOperationsService } from "../model/oe-model-operations.service";
import { OEWorkerListenerService } from "./oe-worker-listener.service";
import { OEValidatorService } from "../oe-validator.service";
import { OESettingsService } from "../basic/oe-settings.service";
import { OELookupService } from "../basic/oe-lookup.service";
import { OEAdapterForwardService } from "../adapter/oe-adapter-forward.service";
import { OEAdapterReverseService } from "../adapter/oe-adapter-reverse.service";
import { OELoggerService } from "../basic/oe-logger.service";
// order-entry models
import { OEInputModel } from "../../data/models/oe-input.model";
// order-entry enums
import { OENNotificationType } from "../../data/enums/oe-notification-type.enum";
import { OENDisplayState } from "../../data/enums/oe-display-state.enum";
import { OENCommand } from "../../data/enums/oe-command.enum";
import { OENOperationMode } from "../../data/enums/oe-operation-mode.enum";
import { OENotificationsService } from "../basic/oe-notifications.service";
import { OEDataModel } from "../../data/models/oe-data.model";
///

@Injectable()
export class OEWorkerActionsService {
  /**********************************************************************/
  /* DATA */

  /**********************************************************************/
  /* SUBSCRIPTIONs */
  private configurationSubscription: Subscription;

  protected orderEntryClearSubscription: Subscription;
  protected modelOrderEntrySubscription: Subscription;
  protected modelOrderErrorSubscription: Subscription;
  protected modelInterventionOrderEntrySubscription: Subscription;

  /**********************************************************************/
  /* CONSTRUCTOR  */
  constructor(
    private oeLogger: OELoggerService,
    private translate: TranslateService,
    private coordinator: OECoordinatorService,
    private getter: OEModelGetterService,
    private setter: OEModelSetterService,
    private operations: OEModelOperationsService,
    private tolerance: OEToleranceService,
    private utility: OEUtilityService,
    private timeMachine: OETimeMachineService,
    private listener: OEWorkerListenerService,
    private validator: OEValidatorService,
    private settings: OESettingsService,
    private lookup: OELookupService,
    private adapterForward: OEAdapterForwardService,
    private adapterReverse: OEAdapterReverseService,
    private notifications: OENotificationsService,
    ////
    protected _rbac: BfxRBACService,
    protected _userProfile: BfxUserProfileService,
    private _capitalizePipe: CapitalizePipe,
    private _orderActionService: OrderDataActionPromiseService,
    private _scratchPadActionService: ScratchPadDataActionPrimaryService,
    protected _orderDataService: OrderDataPromiseLookupService,
    protected _interventionDataService: InterventionDataPromiseLookupService,
    private _orderAcceptanceService: OrderAcceptancePromiseService,
    private _orderApprovalService: OrderSalesApprovalRequestPromiseService,
    protected _traderGroupService: TraderGroupPromiseLookupService,
    protected _salesGroupService: SalesGroupPromiseLookupService,
    protected _profileService: ProfilePromiseActionService,
    public scratchPadDataService: ScratchPadDataPrimaryLookupService,
    private _detailedOrderService: DetailedOrderStatusRequestPromiseService,
  ) {
    this.oeLogger = oeLogger.for(__dirname);
  }

  /**********************************************************************/
  /* REQUEST MODEL */

  /* 	private submitBMarkRequest(refId: string): Promise<boolean> {
		return new Promise((resolve)=>{
			if(this.getter.has(refId)){
				try{
					let errorsMap = new Map<string, Array<OEInputModel>>();
					if(this.getter.isBenchmarkRequest(refId)){ // BMARK
						let errorsOrderData: Array<OEInputModel> = Array<OEInputModel>();
						if(this.adapterForward.prepareBmarkOrderRequestData(refId, errorsOrderData)){
							return true;
						}else{
							errorsMap.set(refId, errorsOrderData);
							return false;
						}
					} else 	{
						logger.out.error(`EXCEPTION: _oeWorker.submitBMarkRequest(): Model with refId: '${refId}' is not a bmark request`);
						resolve(false);
					}				

				}catch(ex){
					logger.out.error(`EXCEPTION: _oeWorker.submitBMarkRequest(): %O`, ex);
					setTimeout(()=>{this.coordinator.cmdChangeDisplayState(refId, OENCommand.STATE_ORDER_INT_ERROR, 'Internal error: exception = ' + ex);}, 0);
					resolve(false);
				}
			}else{
				logger.out.error(`EXCEPTION: _oeWorker.submitBMarkRequest(): Model with refId: '${refId}' does not exist!`);
				resolve(false);
			}
		});
	} */

  /**
   *
   * Convenience method to subvert validation when any states previously accept
   *
   * @param refId
   * @param toleranceAccept tolerance accepted for given order reference id
   * @param toleranceAmountAccept entry amount tolerance accepted for given order reference id
   * @param negativeMarkupAccept Negative markup accepted for given order reference id
   * @param bmZeroAmountAccept Zero BM amount accepted for given order reference id
   * @returns
   */
  protected async submitValidation(
    refId: string,
    toleranceAccept: boolean,
    toleranceAmountAccept: boolean,
    negativeMarkupAccept: boolean,
    bmZeroAmountAccept: boolean,
  ): Promise<boolean> {
    let result = true;

    if (!bmZeroAmountAccept) {
      // BM Zero amount check is first up
      result = this.validator.validateOrderAmount(refId);
    }

    if (result && !negativeMarkupAccept) {
      result = await this.validator.validateMarkup(refId);
    }

    if (result && (!toleranceAccept || !toleranceAmountAccept)) {
      result = await this.validator.validateTolerance(refId);
    }

    return result;
  }

  public submitOrderRequest(refId: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.getter.has(refId)) {
        try {
          let errorsMap = new Map<string, Array<OEInputModel>>();
          if (this.adapterForward.createOrderEntryRequest(refId, errorsMap)) {
            let toleranceAccept = this.getter.getToleranceAccept(refId);
            let toleranceAmountAccept = this.getter.getToleranceAmountAccept(refId);
            let negativeMarkupAccept = this.getter.getNegativeMarkupAccept(refId);
            let bmZeroAmountAccept = this.getter.getBMZeroAmountAccept(refId);

            this.submitValidation(
              refId,
              toleranceAccept,
              toleranceAmountAccept,
              negativeMarkupAccept,
              bmZeroAmountAccept,
            )
              .then((valid: boolean) => {
                if (valid) {
                  let requestModel = this.getter.getRequestModel(refId);
                  // activate worker listeners
                  this.listener.initializeWorkerLifeCycleSubscriptionsForStrategy(refId);
                  this.listener.initializeWorkerInterventionSubscriptionsForStrategy(refId);
                  // move ui to processing state
                  this.coordinator.cmdChangeDisplayState(refId, OENCommand.STATE_ORDER_PROCESSING);
                  // submit the order request data
                  if (requestModel instanceof CubiqTS.LinkedOrderRequestImpl) {
                    // (this.getter.isOperationModeNew(refId) || this.getter.isOperationModeDuplicate(refId)) &&
                    // NEW ORDER, DUPLICATE
                    logger.out.info(
                      `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> NEW ORDER => [${refId}]`,
                    );
                    this.outputExtendedLogging(
                      `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> NEW ORDER => [${refId}] | DUMP:`,
                      requestModel,
                    );

                    this._orderActionService.submitNewOrder(requestModel).then((response: any) => {
                      this.handleSubmissionResponse(refId, response);
                      resolve(true);
                    });
                  } else if (requestModel instanceof CubiqTS.LinkedOrderModificationRequestImpl) {
                    // (this.getter.isOperationModeModify(refId) || this.getter.isOperationModeModify(refId)) &&
                    // MODIFY, MODIFY_INFO
                    logger.out.info(
                      `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> MODIFY ORDER => [${refId}]`,
                    );
                    this.outputExtendedLogging(
                      `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> MODIFY ORDER => [${refId}] | DUMP:`,
                      requestModel,
                    );

                    this._orderActionService
                      .submitModifiedOrder(requestModel)
                      .then((response: any) => {
                        this.handleSubmissionResponse(refId, response);
                        resolve(true);
                      });
                  } else if (requestModel instanceof CubiqTS.FixingOrderRequestImpl) {
                    // BMARK
                    requestModel.stpHold = requestModel.fixingOrderData.stpHold;
                    requestModel.privateFg = requestModel.fixingOrderData.isPrivateOrder;

                    logger.out.info(
                      `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> NEW BENCHMARK ORDER => [${refId}]`,
                    );
                    this.outputExtendedLogging(
                      `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> NEW BENCHMARK ORDER => [${refId}] | DUMP:`,
                      requestModel,
                    );

                    this._orderActionService
                      .submitBmarkOrder(requestModel)
                      .then((response: any) => {
                        this.handleSubmissionResponse(refId, response);
                        resolve(true);
                      });
                  } else if (requestModel instanceof CubiqTS.FixingOrderModificationRequestImpl) {
                    // BMARK
                    requestModel.stpHold = requestModel.fixingOrderData.stpHold;
                    requestModel.privateFg = requestModel.fixingOrderData.isPrivateOrder;

                    logger.out.info(
                      `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> MODIFY BENCHMARK ORDER => [${refId}]`,
                    );
                    this.outputExtendedLogging(
                      `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> MODIFY BENCHMARK ORDER => [${refId}] | DUMP:`,
                      requestModel,
                    );

                    this._orderActionService
                      .submitBmarkOrderModify(requestModel)
                      .then((response: any) => {
                        this.handleSubmissionResponse(refId, response);
                        resolve(true);
                      });
                  } else {
                    let message: string = `Submit failed, invalid modeType or model for ${refId}`;
                    logger.out.error(`EXCEPTION: _oeWorker.submitOrderRequest(): ${message}`);

                    setTimeout(() => {
                      this.coordinator.cmdChangeDisplayState(
                        refId,
                        OENCommand.STATE_ORDER_INT_ERROR,
                        `Internal error: exception = ${message}`,
                      );
                    }, 0);
                    resolve(false);
                  }
                } else {
                  // state change handled in this.validateTolerance(refId)
                  resolve(true);
                }
              })
              .catch((reason: any) => {
                logger.out.error(`EXCEPTION: _oeWorker.submitOrderRequest(): %O`, reason);
                setTimeout(() => {
                  this.coordinator.cmdChangeDisplayState(
                    refId,
                    OENCommand.STATE_ORDER_INT_ERROR,
                    "Internal error: exception = " + reason,
                  );
                }, 0);
                resolve(false);
              });
          } else {
            // errors on model creation
            // notify on errors
            this.handleAndNotifyAboutValidationErrorsThatAreStoredInAMapThatHasAnArrayInside(
              refId,
              errorsMap,
            );
            resolve(false);
          }
        } catch (ex) {
          logger.out.error(`EXCEPTION: _oeWorker.submitOrderRequest(): %O`, ex);
          setTimeout(() => {
            this.coordinator.cmdChangeDisplayState(
              refId,
              OENCommand.STATE_ORDER_INT_ERROR,
              "Internal error: exception = " + ex,
            );
          }, 0);
          resolve(false);
        }
      } else {
        logger.out.error(
          `EXCEPTION: _oeWorker.submitOrderRequest(): Model with refId: '${refId}' does not exist!`,
        );
        resolve(false);
      }
    });
  }

  // DO NOT RENAME, Keep calm, Blame Blagoj for the function name, and carry on
  private handleAndNotifyAboutValidationErrorsThatAreStoredInAMapThatHasAnArrayInside(
    refId: string,
    errorsMap: Map<string, Array<OEInputModel>>,
  ): void {
    if (errorsMap.size > 0) {
      errorsMap.forEach((value, key) => {
        this.setter.reportValidationErrors(key);
      });
      // notify interface components
      let errorToReport = errorsMap.entries().next().value;
      if (this.getter.isRootNodeAlone(refId)) {
        // single node
        this.coordinator.cmdInvalidInput(refId, errorToReport[1]);
      } else if (this.getter.isActivelyDisplayed(errorToReport[0])) {
        // multi-node but selected
        this.validator.notifyOnValidationErrors(errorToReport[0], errorToReport[1]);
      } else {
        // multi node - not selected
        this.validator.activateAndNotifyOnValidationErrors(errorToReport[0], errorToReport[1]);
      }
    }
  }

  private handleSubmissionResponse(refId: string, response: any): void {
    if (response != null) {
      //this.config.debug ? logger.out.info(`OrderEntry-> SUBMIT ORDER Response received! [response]= %O`, response): '';
      if (
        response.errorMessages != null &&
        response.errorMessages instanceof Array &&
        response.errorMessages.length > 0
      ) {
        let errors = this.handleErrors(response.errorMessages);

        logger.out.info(
          `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> ORDER [${refId}] Errors= %O`,
          errors,
        );

        this.coordinator.cmdChangeDisplayState(refId, OENCommand.STATE_ORDER_REJECTED, errors);
      }
    } else {
      this.coordinator.cmdChangeDisplayState(
        refId,
        OENCommand.STATE_ORDER_INT_ERROR,
        "Internal error: Invalid server response!",
      );
    }
  }

  public saveOrderRequest(refId: string): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.getter.has(refId)) {
        try {
          let errorsMap = new Map<string, Array<OEInputModel>>();
          if (this.adapterForward.createOrderEntryRequest(refId, errorsMap)) {
            let requestModel = this.getter.getRequestModel(refId);
            if (requestModel) {
              // activate worker listeners
              this.listener.initializeWorkerLifeCycleSubscriptionsForStrategy(refId);
              this.listener.initializeWorkerInterventionSubscriptionsForStrategy(refId);
              this.listener.initializeWorkerScratchpadSubscriptionsForStrategy(refId);
              // move ui to processing state
              this.coordinator.cmdChangeDisplayState(refId, OENCommand.STATE_ORDER_PROCESSING);
              // submit the order request data
              if (requestModel instanceof CubiqTS.LinkedOrderRequestImpl) {
                // (this.getter.isOperationModeNew(refId) || this.getter.isOperationModeDuplicate(refId)) &&
                //SAVE NEW ORDER
                logger.out.info(
                  `UI-MAIN: OrderEntry@${Date.now()}: SAVE >>> NEW ORDER => [${refId}]`,
                );
                this.outputExtendedLogging(
                  `UI-MAIN: OrderEntry@${Date.now()}: SAVE >>> NEW ORDER => [${refId}] | DUMP:`,
                  requestModel,
                );

                this._scratchPadActionService.saveNewOrder(requestModel).then((response: any) => {
                  this.handleSaveResponse(refId, response);
                  resolve(true);
                });
              } else if (requestModel instanceof CubiqTS.LinkedOrderModificationRequestImpl) {
                //SAVE MODIFIED ORDER
                logger.out.info(
                  `UI-MAIN: OrderEntry@${Date.now()}: SAVE >>> MODIFY ORDER => [${refId}]`,
                );
                this.outputExtendedLogging(
                  `UI-MAIN: OrderEntry@${Date.now()}: SAVE >>> MODIFY ORDER => [${refId}] | DUMP:`,
                  requestModel,
                );

                requestModel.linkReference = requestModel.rootOrder.externalClientReference;
                this._scratchPadActionService.saveNewOrder(requestModel).then((response: any) => {
                  this.handleSaveResponse(refId, response);
                  resolve(true);
                });
              } else if (requestModel instanceof CubiqTS.FixingOrderRequestImpl) {
                //SAVE BENCHMARK
                logger.out.info(
                  `UI-MAIN: OrderEntry@${Date.now()}: SAVE >>> BMARK ORDER => [${refId}]`,
                );
                this.outputExtendedLogging(
                  `UI-MAIN: OrderEntry@${Date.now()}: SAVE >>> BMARK ORDER => [${refId}] | DUMP:`,
                  requestModel,
                );

                this._scratchPadActionService.saveNewOrder(requestModel).then((response: any) => {
                  this.handleSaveResponse(refId, response);
                  resolve(true);
                });
              } else {
                let message: string = `Save order failed, invalid modeType or model for ${refId}`;
                logger.out.error(`EXCEPTION: _oeWorker.saveOrderRequest(): ${message}`);
                setTimeout(() => {
                  this.coordinator.cmdChangeDisplayState(
                    refId,
                    OENCommand.STATE_ORDER_INT_ERROR,
                    `Internal error: exception = ${message}`,
                  );
                }, 0);
                resolve(false);
              }
            }
          } else {
            // errors on model creation
            this.handleAndNotifyAboutValidationErrorsThatAreStoredInAMapThatHasAnArrayInside(
              refId,
              errorsMap,
            );
            resolve(false);
          }
        } catch (ex) {
          logger.out.error(`EXCEPTION: _oeWorker.saveOrderRequest(): %O`, ex);
          setTimeout(() => {
            this.coordinator.cmdChangeDisplayState(
              refId,
              OENCommand.STATE_ORDER_INT_ERROR,
              "Internal error: exception = " + ex,
            );
          }, 0);
          resolve(false);
        }
      } else {
        logger.out.error(
          `EXCEPTION: _oeWorker.saveOrderRequest(): Model with refId: '${refId}' does not exist!`,
        );
        resolve(false);
      }
    });
  }

  private handleSaveResponse(refId: string, response: any): void {
    if (response != null) {
      //this.config.debug ? logger.out.info(`OrderEntry-> SUBMIT ORDER Response received! [response]= %O`, response): '';
      if (
        response.errorMessages != null &&
        response.errorMessages instanceof Array &&
        response.errorMessages.length > 0
      ) {
        let errors = this.handleErrors(response.errorMessages);

        logger.out.info(
          `UI-MAIN: OrderEntry@${Date.now()}: SAVE >>> ORDER [${refId}] Errors= %O`,
          errors,
        );

        this.coordinator.cmdChangeDisplayState(refId, OENCommand.STATE_ORDER_REJECTED, errors);
      }
    } else {
      this.coordinator.cmdChangeDisplayState(
        refId,
        OENCommand.STATE_ORDER_INT_ERROR,
        "Internal error: Invalid server response!",
      );
    }
  }

  /**********************************************************************/
  /* MODIFY INFO submit  */

  public submitModifyInfoRequest(refId: string): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      if (this.getter.has(refId)) {
        try {
          let issuerRefId = this.getter.getModifyIssuerRefId(refId);
          if (
            this.getter.has(issuerRefId) &&
            this.adapterForward.createModifyInfoRequest(issuerRefId)
          ) {
            // move ui to processing state
            this.coordinator.cmdChangeDisplayState(refId, OENCommand.STATE_ORDER_PROCESSING);
            // submit the order request data

            let modifyInfoRequestModel = this.getter.getModifyInfoRequestModel(issuerRefId);
            if (modifyInfoRequestModel instanceof CubiqTS.LinkedOrderInfoModificationRequestImpl) {
              /*********************************************/
              /* Craft a message for public consumption*/
              let activeRefId = this.getter.getActivelyDisplayedRefId(issuerRefId);
              let successMessage = this.craftSuccessMessageForModifyInfo(issuerRefId);
              /*********************************************/
              /* Destroy subscription for terminal legs */
              let propagationTree = this.getter.getStrategyNodesListRoot(issuerRefId);
              propagationTree.forEach((itemRefId: string) => {
                if (this.getter.isInTerminalState(itemRefId)) {
                  this.listener.destroyWorkerLifeCycleSubscriptionsForStrategy(itemRefId);
                }
              });
              /*********************************************/
              /* Log out the submission dump */
              let issuerOrderId = this.getter.getOrderId(issuerRefId);
              // SUBMIT LOG
              logger.out.info(
                `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> MODIFY-INFO => [${activeRefId}] | IssuerRefId: ${issuerRefId} | IssuerOrderId: ${issuerOrderId}`,
              );
              this.outputExtendedLogging(
                `UI-MAIN: OrderEntry@${Date.now()}: SUBMIT >>> MODIFY-INFO => [${activeRefId}] | IssuerRefId: ${issuerRefId} | IssuerOrderId: ${issuerOrderId} | dump: `,
                modifyInfoRequestModel,
              );
              //

              const shouldMonitor = this.getter.supportsMonitoringExecution(refId);
              const successState = shouldMonitor
                ? OENCommand.STATE_MONITOR_EXECUTION
                : OENCommand.STATE_ORDER_SUCCESS;

              /*********************************************/
              /* SUBMIT MODIFY INFO */
              this._orderActionService
                .submitModifyInfo(modifyInfoRequestModel)
                .then((response: any) => {
                  if (response != null) {
                    this.handleSubmissionResponse(refId, response);
                    if (!shouldMonitor) {
                      this.listener.destroyWorkerLifeCycleSubscriptionsForStrategy(refId);
                    } else {
                      this.coordinator.cmdChangeDisplayState(refId, successState);
                      this.coordinator.cmdLockInterfaceControls(refId, false);
                    }
                  } else {
                    let newActiveRefId = this.getter.getActivelyDisplayedRefId(refId);
                    const data = { close: true, message: successMessage };
                    this.coordinator.cmdChangeDisplayState(newActiveRefId, successState, data);
                    this.coordinator.cmdLockInterfaceControls(activeRefId, false);
                  }
                  resolve(true);
                });
            } else {
              let message: string = `Submit failed, invalid modeType or model for ${refId}`;
              logger.out.error(`EXCEPTION: _oeWorker.submitOrderRequest(): ${message}`);
              setTimeout(() => {
                this.coordinator.cmdChangeDisplayState(
                  refId,
                  OENCommand.STATE_ORDER_INT_ERROR,
                  `Internal error: ${message}`,
                );
              }, 0);
              resolve(false);
            }
          } else {
            let message: string = `Failed to create ModifyInfoRequestModel for ${refId}`;
            logger.out.error(`ERROR: _oeWorker.submitModifyInfoRequest():  ${message}`);
            setTimeout(() => {
              this.coordinator.cmdChangeDisplayState(
                refId,
                OENCommand.STATE_ORDER_INT_ERROR,
                `Internal error: ${message}`,
              );
            }, 0);
            resolve(false);
          }
        } catch (ex) {
          logger.out.error(`EXCEPTION: _oeWorker.submitModifyInfoRequest(): %O`, ex);
          setTimeout(() => {
            this.coordinator.cmdChangeDisplayState(
              refId,
              OENCommand.STATE_ORDER_INT_ERROR,
              "Internal error: exception = " + ex,
            );
          }, 0);
          resolve(false);
        }
      } else {
        let message: string = `Model with refId: '${refId}' does not exist!`;
        logger.out.error(`ERROR: _oeWorker.submitModifyInfoRequest():  ${message}`);
        setTimeout(() => {
          this.coordinator.cmdChangeDisplayState(
            refId,
            OENCommand.STATE_ORDER_INT_ERROR,
            `Internal error: ${message}`,
          );
        }, 0);
        resolve(false);
      }
    });
  }

  private craftSuccessMessageForModifyInfo(refId: string): string {
    try {
      let orderState = this.getter.getSrvOrderState(refId);
      let traderGroup = this.getter.getTraderGroup(refId);
      let successMessage =
        traderGroup != null && traderGroup instanceof CubiqTS.TradingGroupImpl
          ? orderState != null
            ? CubiqTS.OrderState[orderState].replace(/_/g, " ") + ": " + traderGroup.groupCode
            : "ACTIVE: " + traderGroup.groupCode
          : "Info modification done!";
      successMessage = this._capitalizePipe.transform(successMessage.toLowerCase(), true);
      return successMessage;
    } catch (ex) {
      logger.out.warn(`EXCEPTION: _oeWorker.craftSuccessMessageForModifyInfo(): %O`, ex);
      return "SUCCESS: Info modified";
    }
  }

  /**********************************************************************/
  /* AMEND MARKUP submit  */
  // returns true if validation error, false otherwise
  public submitAmendMarkupRequest(refId: string): boolean {
    if (this.getter.has(refId)) {
      try {
        let issuerRefId = this.getter.getModifyIssuerRefId(refId);
        if (this.getter.has(issuerRefId)) {
          let errorsMap = new Map<string, Array<OEInputModel>>();
          let amendMarkupRequest = this.adapterForward.createAmendMarkupRequest(
            issuerRefId,
            errorsMap,
          );
          if (errorsMap.size > 0) {
            this.handleAndNotifyAboutValidationErrorsThatAreStoredInAMapThatHasAnArrayInside(
              refId,
              errorsMap,
            );
            return true;
          } else {
            // move ui to processing state
            this.coordinator.cmdChangeDisplayState(refId, OENCommand.STATE_ORDER_PROCESSING);
            // submit the order request data
            if (amendMarkupRequest instanceof CubiqTS.AmendMarkupSalesApprovalRequestImpl) {
              let orderId = this.getter.getOrderId(issuerRefId);
              //
              let orderState = this.getter.getSrvOrderState(issuerRefId);
              let traderGroup = this.getter.getTraderGroup(issuerRefId);
              let successMessage =
                traderGroup != null && traderGroup instanceof CubiqTS.TradingGroupImpl
                  ? orderState != null
                    ? CubiqTS.OrderState[orderState].replace(/_/g, " ") +
                      ": " +
                      traderGroup.groupCode
                    : "ACTIVE: " + traderGroup.groupCode
                  : "Info modification done!";
              successMessage = this._capitalizePipe.transform(successMessage.toLowerCase(), true);
              // Destroy subscription for terminal legs
              let propagationTree = this.getter.getStrategyNodesListRoot(issuerRefId);
              propagationTree.forEach((itemRefId: string) => {
                if (this.getter.isInTerminalState(itemRefId)) {
                  this.listener.destroyWorkerLifeCycleSubscriptionsForStrategy(refId);
                  this.listener.destroyWorkerInterventionSubscriptionsForStrategy(refId);
                }
              });
              // SUBMIT LOG
              logger.out.info(
                `UI-MAIN: SUBMIT - Amend Markup APPROVE -> IssuerRefId: ${issuerRefId} | OrderId: ${orderId}`,
              ); // | Request Dump: %O`, amendMarkupRequest): '';
              //
              this._orderActionService
                .amendMarkupApproveAction(amendMarkupRequest)
                .then((response: any) => {
                  if (response != null) {
                    this.handleSubmissionResponse(refId, response);
                    this.listener.destroyWorkerLifeCycleSubscriptionsForStrategy(refId);
                    this.listener.destroyWorkerInterventionSubscriptionsForStrategy(refId);
                  } else {
                    let activeRefId = this.getter.getActivelyDisplayedRefId(refId);
                    this.coordinator.cmdChangeDisplayState(
                      activeRefId,
                      OENCommand.STATE_ORDER_SUCCESS,
                      { close: true, message: successMessage },
                    );
                    this.coordinator.cmdLockInterfaceControls(activeRefId, false);
                    this.coordinator.cmdCloseOrderEntryScreen(activeRefId);
                  }
                });
            } else {
              logger.out.error(
                `ERROR: _oeWorker.submitAmendMarkupRequest(): Invalid request model: %O`,
                amendMarkupRequest,
              );
            }
          }
        }
      } catch (ex) {
        logger.out.error(`EXCEPTION: _oeWorker.submitAmendMarkupRequest(): %O`, ex);
        this.coordinator.cmdChangeDisplayState(
          refId,
          OENCommand.STATE_ORDER_INT_ERROR,
          "Internal error: exception = " + ex,
        );
      }
    } else {
      logger.out.error(
        `ERROR: _oeWorker.submitAmendMarkupRequest(): Invalid model for refId: '${refId}'`,
      );
    }
    return false;
  }

  /**********************************************************************/
  /* LOAD OrderDataImpl  */

  public resolveRefIdForOrderId(orderId: string): Promise<string> {
    return new Promise((res, rej) => {
      this._orderDataService.getOrderReference(orderId).then(
        (resolveRefId: string) => {
          res(resolveRefId);
        },
        (reject) => {
          rej(reject);
        },
      );
    });
  }

  public getOrderPreInitializationData(orderId: string, mode: OENOperationMode): Promise<any> {
    return new Promise((res, rej) => {
      if (mode === OENOperationMode.EDIT) {
        // Editing an unsaved order, either copied or imported
        this.scratchPadDataService.getOrderData(orderId).then((respo: any) => {
          respo.ref = orderId;
          res(respo);
        });
      } else {
        this._orderDataService.getModifyPreInitDataForOrderId(orderId).then(
          (data: any) => {
            if (data == null && mode === OENOperationMode.DUPLICATE) {
              this._detailedOrderService.request(orderId).then((respo: any) => {
                res(respo);
              });
            } else {
              res(data);
            }
          },
          (reject) => {
            rej(reject);
          },
        );
      }
    });
  }

  public getInterventionPreInitializationData(orderId: string): Promise<any> {
    return new Promise((res, rej) => {
      this._interventionDataService.getInterventionData(orderId).then(
        (data: any) => {
          res(data);
        },
        (reject) => {
          rej(reject);
        },
      );
    });
  }

  // data param only used for AMEND_MARKUP
  public synthesizeOrderEntryModelForOrderId(
    orderId: string,
    mode: OENOperationMode,
    resRefId: string = null,
    data: any = null,
  ): Promise<any> {
    return new Promise((res, rej) => {
      if (mode === OENOperationMode.EDIT) {
        // scratchpad
        this.outputExtendedLogging(
          `UI-MAIN: OrderEntry@${Date.now()}: SYNTHESIZE MODEL (ID: ${orderId}) for ${
            OENOperationMode[mode]
          } => Response:`,
          data,
        );
        this.processOrderDataImplModel(data, orderId, mode, resRefId).then(
          (result: any) => {
            // Fix for OMS-34113 - subscription need as it might be saved from blotter while oe is open
            this.listener.initializeWorkerScratchpadSubscriptionsForStrategy(resRefId);
            res(result);
          },
          (reject: any) => {
            rej(reject);
          },
        );
      } else if (
        mode === OENOperationMode.DUPLICATE ||
        mode === OENOperationMode.MODIFY_INFO ||
        mode === OENOperationMode.MONITOR_EXECUTION
      ) {
        this._detailedOrderService.request(orderId).then((response: any) => {
          this.outputExtendedLogging(
            `UI-MAIN: OrderEntry@${Date.now()}: SYNTHESIZE MODEL (ID: ${orderId}) for ${
              OENOperationMode[mode]
            } => Response:`,
            response,
          );
          this.processOrderDataImplModel(response, orderId, mode, resRefId).then(
            (result: any) => {
              res(result);
            },
            (reject: any) => {
              rej(reject);
            },
          );
        });
      } else if (mode === OENOperationMode.AMEND_MARKUP) {
        if (data != null && data instanceof CubiqTS.InterventionEventImpl) {
          // TODO implement condition checking if its locked to the current user
          if (data.lockUserId == null) {
            // not locked
            this._orderActionService.amendMarkupOrderLock(orderId).then(
              (response: any) => {
                this.outputExtendedLogging(
                  `UI-MAIN: OrderEntry@${Date.now()}: SYNTHESIZE MODEL (ID: ${orderId}) for ${
                    OENOperationMode[mode]
                  } with LOCK => Response:`,
                  response,
                );

                let orderData = null;
                // select proper root for root sibling relationship, process errors if any.
                try {
                  orderData = this.processLockResponseAndHandleErrors(orderId, response);
                } catch (ex) {
                  rej(ex);
                  return;
                }
                // just a check
                let resRefIdPresentInModel: boolean =
                  this.adapterReverse.checkIfRefIdPresentInOrderData(resRefId, orderData);
                if (orderData.clOrdID !== resRefId && !resRefIdPresentInModel) {
                  logger.out.error(
                    `ERROR: _oeWorker.synthesizeOrderEntryModelForOrderId(): Root Ids mismatch: resRefId = '${resRefId}' | clOrdID = '${orderData.clOrdID}', also order NOT present in strategy structure!`,
                  );
                }

                this.processOrderDataImplModel(orderData, orderId, mode, resRefId).then(
                  (result: any) => {
                    res(result);
                  },
                  (reject: any) => {
                    rej(reject);
                  },
                );
              },
              (error: any) => {
                rej(error);
              },
            );
          } else if (data.lockUserId.toString() === this.settings.currentUserId) {
            // locked to me
            this._detailedOrderService.request(orderId).then(
              (response: any) => {
                this.outputExtendedLogging(
                  `UI-MAIN: OrderEntry@${Date.now()}: SYNTHESIZE MODEL (ID: ${orderId}) for ${
                    OENOperationMode[mode]
                  } already LOCKED => Response:`,
                  response,
                );

                this.processOrderDataImplModel(response, orderId, mode, resRefId).then(
                  (result: any) => {
                    res(result);
                  },
                  (reject: any) => {
                    rej(reject);
                  },
                );
              },
              (error: any) => {
                rej(error);
              },
            );
          } else {
            rej(
              `Locked to userId: '${data.lockUserId.toString()}', current userId: ${
                this.settings.currentUserId
              }`,
            );
          }
        } else {
          rej(`PreInitialization for AMEND MARKUP failed, intervention !`);
        }
      } else if (mode === OENOperationMode.MODIFY) {
        this._orderActionService.modifyOrderLock(orderId).then((response: any) => {
          this.outputExtendedLogging(
            `UI-MAIN: OrderEntry@${Date.now()}: SYNTHESIZE MODEL (ID: ${orderId}) for MODIFY => Response:`,
            response,
          );

          let orderData = null;
          try {
            orderData = this.processLockResponseAndHandleErrors(orderId, response);
          } catch (ex) {
            rej(ex);
            return;
          }
          // just a check
          let resRefIdPresentInModel: boolean = this.adapterReverse.checkIfRefIdPresentInOrderData(
            resRefId,
            orderData,
          );
          if (orderData.clOrdID !== resRefId && !resRefIdPresentInModel) {
            logger.out.error(
              `ERROR: _oeWorker.synthesizeOrderEntryModelForOrderId(): Root Ids mismatch: resRefId = '${resRefId}' | clOrdID = '${orderData.clOrdID}', also order NOT present in strategy structure!`,
            );
          }

          /// processing order data
          if (resRefIdPresentInModel && this.getter.has(resRefId)) {
            // model should already be created in pre-initialization
            if (!this.getter.isOperationModeModify(resRefId)) {
              // Old fix for OMS-25348
              this.coordinator.cmdCloseOrderEntryScreen(orderData.clOrdID); // this point should not be reached
              setTimeout(() => {
                this.processOrderDataImplModel(
                  orderData,
                  orderId,
                  mode,
                  resRefId,
                  response.extendedInfo.get("orderRef"),
                ).then(
                  (result: any) => {
                    res(result);
                  },
                  (reject: any) => {
                    rej(reject);
                  },
                );
              }, 300);
            } else {
              this.processOrderDataImplModel(
                orderData,
                orderId,
                mode,
                resRefId,
                response.extendedInfo.get("orderRef"),
              ).then(
                (result: any) => {
                  let tooltip: string = "";
                  let errorMessages =
                    orderData.orderErrors != null && orderData.orderErrors.errorMessages != null
                      ? orderData.orderErrors.errorMessages
                      : null;
                  if (Array.isArray(errorMessages) && errorMessages.length > 0) {
                    tooltip = this.handleErrors(errorMessages);
                  }
                  //
                  if (typeof tooltip === "string" && tooltip.length > 1) {
                    res({ id: result, tooltip: tooltip });
                  } else {
                    res(result);
                  }
                },
                (reject: any) => {
                  rej(reject);
                },
              );
            }
          } else {
            logger.out.error(
              `ERROR: _oeWorker.synthesizeOrderEntryModelForOrderId(): Pre-initialization failed or missing clOrdID in orderData!`,
            );
            rej("Pre-initialization failed or missing orderData");
          }
        });
      } else if (mode === OENOperationMode.MODIFY_SCRATCHPAD) {
        this.scratchPadDataService.getOrderDataForOrderId(orderId).then((response: any) => {
          this.outputExtendedLogging(
            `UI-MAIN: OrderEntry@${Date.now()}: SYNTHESIZE MODEL (ID: ${orderId}) for MODIFY_SCRATCPAD => Response:`,
            response,
          );

          let orderData = response;
          // try{ orderData = this.processLockResponseAndHandleErrors(orderId, response); }catch(ex){ rej(ex); return;}
          // just a check
          let resRefIdPresentInModel: boolean = this.adapterReverse.checkIfRefIdPresentInOrderData(
            resRefId,
            orderData,
          );
          if (orderData.clOrdID !== resRefId && !resRefIdPresentInModel) {
            logger.out.error(
              `ERROR: _oeWorker.synthesizeOrderEntryModelForOrderId(): Root Ids mismatch: resRefId = '${resRefId}' | clOrdID = '${orderData.clOrdID}', also order NOT present in strategy structure!`,
            );
          }

          /// processing order data
          if (resRefIdPresentInModel && this.getter.has(resRefId)) {
            // model should already be created in pre-initialization
            this.processOrderDataImplModel(orderData, orderId, mode, resRefId).then(
              (result: any) => {
                res(result);
              },
              (reject: any) => {
                rej(reject);
              },
            );
          } else {
            logger.out.error(
              `ERROR: _oeWorker.synthesizeOrderEntryModelForOrderId(): Pre-initialization failed or missing clOrdID in orderData!`,
            );
            rej("Pre-initialization failed or missing orderData");
          }
        });
      } else {
        logger.out.error(
          `ERROR: _oeWorker.synthesizeOrderEntryModelForOrderId(): Unknown mode: '${mode}', synth interrupted!`,
        );
      }
    });
  }

  /*
		Response orderData selection logic!
		The logic below is implemented as part of the solution to: https://www.bcdfx.com/ijira/browse/OMS-24723
		In the case where the root has sibling relationship, the rootOrderData (actual root) is selected based on the
		orderId selected to modify. So either node in the root sibling relationship can become the root.
		-----------------------------------------------------------------------------------
		NOTE: Used for handling modification lock response and amend markup lock response.
	*/

  private processLockResponseAndHandleErrors(
    issuerOrderId: string,
    response: any,
  ): CubiqTS.OrderDataImpl {
    if (
      response != null &&
      (response instanceof CubiqTS.StrategyModificationLockResponseImpl ||
        response instanceof CubiqTS.StrategyAmendModificationLockResponseImpl)
    ) {
      if (
        response.orderData != null &&
        Array.isArray(response.orderData) &&
        response.orderData.length > 0
      ) {
        let orderData = null;
        if (
          response.orderData.length === 1 &&
          response.orderData[0] instanceof CubiqTS.OrderDataImpl
        ) {
          orderData = response.orderData[0];
        } else if (response.orderData.length > 1) {
          for (let i = 0; i < response.orderData.length; i++) {
            if (
              response.orderData[i] instanceof CubiqTS.OrderDataImpl &&
              response.orderData[i].orderId.toString() === issuerOrderId
            ) {
              orderData = response.orderData[i];
            }
          }
          if (orderData == null && response.orderData[0] instanceof CubiqTS.OrderDataImpl) {
            orderData = response.orderData[0];
            logger.out.warn(
              `ERROR: _oeWorker.synthesizeOrderEntryModelForOrderId(): OrderId ${issuerOrderId} not found in response, selected orderData index 0! response: %O`,
              response,
            );
          }
        }
        return orderData;
      }
    }
    // Error handling
    logger.out.warn(
      `WARN: _oeWorker.processLockResponseAndHandleErrors(): Response is invalid! response = %O`,
      response,
    );
    if (
      response != null &&
      response.lockErrors != null &&
      response.lockErrors.errorMessages.length > 0
    ) {
      let knownErrors = [
        "order.notModifiable.triggered",
        "access.error.user.strategy.action.not.allowed",
        "order.lockedByAnotherUser",
      ];
      let error = JSON.parse(response.lockErrors.errorMessages[0]);
      if (knownErrors.includes(error["id"])) {
        this.notifications.sendErrorNotification(
          OENNotificationType.ERROR_MODIFY_OUT_PERMISSIONS,
          response,
          issuerOrderId,
          response.extendedInfo.get("orderRef"),
        );
      } else {
        this.notifications.sendErrorNotification(
          OENNotificationType.ERROR_MODIFY_OUT_SERVER_FAIL,
          response,
          issuerOrderId,
          response.extendedInfo.get("orderRef"),
        );
      }
    } else {
      this.notifications.sendErrorNotification(
        OENNotificationType.ERROR_MODIFY_OUT_SERVER_FAIL,
        response,
        issuerOrderId,
        response.extendedInfo.get("orderRef"),
      );
    }
    throw "Response is null, or response type not supported!";
  }

  private processOrderDataImplModel(
    orderData: any,
    orderId: string,
    mode: OENOperationMode,
    resRefId: string = null,
    orderRef: string = null,
  ): Promise<string> {
    return new Promise((res, rej) => {
      // MODIFY, MODIFY INFO, DUPLICATE, AMEND MARKUP, EDIT, MODIFY_SCRATCHPAD, MONITOR_EXECUTION
      if (orderData != null && orderData instanceof CubiqTS.OrderDataImpl) {
        if (orderData.clOrdID != null) {
          this.operations.addInstance(orderData, orderId, mode, resRefId).then((refId: string) => {
            if (refId != null) {
              if (mode === OENOperationMode.MODIFY) {
                this.setter.setLockedForModification(refId, orderData.lockUserId.toString());
              }
              res(refId);
            } else {
              rej(`Errors while building Order Entry Model!`);
            }
          });
        } else {
          rej(`Order with id: '${orderId}' has no reference!`);
        }
      } else {
        if (mode === OENOperationMode.MODIFY) {
          this.notifications.sendErrorNotification(
            OENNotificationType.ERROR_MODIFY_OUT_PERMISSIONS,
            orderData,
            orderId,
            orderRef,
          );
        }
        rej(`Order data not available for order '${orderId}'`);
      }
    });
  }

  public issueModificationRequestWithoutLoad(activeRefId: string): Promise<boolean> {
    return new Promise((res, rej) => {
      if (activeRefId != null && this.getter.has(activeRefId)) {
        //let orderId = this.getter.getOrderIdForRefIdOrRoot(refId);
        let orderId = this.getter.getModifyIssuerOrderId(activeRefId); //orderIdIssued
        let issuerRefId = this.getter.getRefIdForOrderId(activeRefId, orderId);
        /* if(orderId !== orderIdIssued){
					logger.out.error(`DEV-TEST ERROR: _oeWorker.issueModificationRequestWithoutLoad(): OrderIds mismatch! orderId='${orderId} | issuedOrderId='${orderIdIssued}'`);
				} */

        if (orderId == activeRefId) {
          res(false);
          return;
        }

        if (orderId != null && orderId !== "") {
          this.listener.initializeWorkerLifeCycleSubscriptionsForStrategy(activeRefId);
          this._orderActionService.modifyOrderLock(orderId).then(
            (response: any) => {
              if (
                response.orderData != null &&
                response.orderData[0] instanceof CubiqTS.OrderDataImpl
              ) {
                let rootOrderData = response.orderData[0];
                let orderData = this.adapterReverse.findOrderDataForRefId(
                  issuerRefId,
                  rootOrderData,
                );
                if (orderData != null && orderData instanceof CubiqTS.OrderDataImpl) {
                  if (
                    orderData.orderState === CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED ||
                    orderData.orderState === CubiqTS.OrderState.IN_MODIFICATION ||
                    orderData.orderState === CubiqTS.OrderState.EXT_MODIFY_ACCEPTANCE_NEEDED ||
                    // OMS-33241 handle edge case for sibling with active parent
                    (orderData.orderState === CubiqTS.OrderState.REJECTED &&
                      orderData.parentRelationship != null)
                  ) {
                    this.setter.setLockedForModification(
                      issuerRefId,
                      orderData.lockUserId.toString(),
                    );
                    this.setter.setSrvOrderState(issuerRefId, orderData.orderState);

                    let acceptanceNeeded: boolean =
                      orderData.orderState === CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED;
                    if (!acceptanceNeeded) {
                      this.coordinator.cmdUnlockInterfaceControls(activeRefId);
                    }

                    if (
                      orderData.clientCode
                        ? orderData.clientCode.indexOf("__bfx_privatization") == 0
                        : false
                    ) {
                      logger.out.warn(
                        `${this.constructor.name}.issueModificationRequestWithoutLoad(${activeRefId}) modification privatized`,
                      );
                      this.setter.setModificationPrivatized(issuerRefId);
                    }

                    res(acceptanceNeeded);
                  } else {
                    logger.out.error(
                      `ERROR: _oeWorker.issueModificationRequestWithoutLoad(): Invalid order state received! State: ${orderData.orderState} should be IN_MODIFICATION (${CubiqTS.OrderState.IN_MODIFICATION}) or MODIFY_ACCEPTANCE_NEEDED (${CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED})`,
                    );
                    res(null);
                  }
                } else {
                  logger.out.error(
                    `ERROR: _oeWorker.issueModificationRequestWithoutLoad(): Response success but refId mismatch! Request refId: ${activeRefId} | Server clOrdID: ${orderData.clOrdID}`,
                  );
                  res(null);
                }
              } else {
                this.notifications.sendErrorNotification(
                  OENNotificationType.ERROR_MODIFY_OUT_EDIT,
                  response,
                  orderId,
                  response.extendedInfo.get("orderRef"),
                );
                res(null);
              }
            },
            (error: any) => {
              logger.out.error(
                `ERROR: _oeWorker.issueModificationRequestWithoutLoad(): Server error response: %O`,
                error,
              );
              res(null);
            },
          );
        } else {
          logger.out.error(
            `ERROR: _oeWorker.issueModificationRequestWithoutLoad(): OrderId (${orderId}) for refId '${activeRefId}' not found!`,
          );
          res(null);
        }
      } else {
        logger.out.error(
          `ERROR: _oeWorker.issueModificationRequestWithoutLoad(): Model with refId '${activeRefId}' not found!`,
        );
        res(null);
      }
    });
  }

  /**********************************************************************/
  /* ORDER LIFE-CYCLE SUBSCRIPTIONS & EVENT HANDLERS */

  /**********************************************************************/
  /* ACTIONS */

  public submitDIApprove(refId: string): Promise<CubiqTS.ErrorsImpl> {
    const remoteAction = (orderIds) => {
      return this._orderApprovalService.requestApproval(
        orderIds,
        "",
        CubiqTS.SalesApprovalAction.APPROVE,
      );
    };
    return this.executeOrderServerAction("DIApprove", refId, remoteAction);
  }

  public submitDIReject(refId: string): Promise<CubiqTS.ErrorsImpl> {
    const remoteAction = (orderIds) => {
      return this._orderApprovalService.requestApproval(
        orderIds,
        "",
        CubiqTS.SalesApprovalAction.REJECT,
      );
    };
    return this.executeOrderServerAction("DIReject", refId, remoteAction);
  }

  public submitToleranceAccept(refId: string): void {
    if (this.getter.has(refId)) {
      let accepted: boolean = this.getter.getToleranceAccept(refId);
      if (!accepted) {
        this.setter.setToleranceAccept(refId, true);
      } else {
        this.setter.setToleranceAmountAccept(refId, true);
      }
      this.submitOrderRequest(refId);
    }
  }

  public submitNegativeMarkupAccept(refId: string): void {
    if (this.getter.has(refId)) {
      let accepted: boolean = this.getter.getNegativeMarkupAccept(refId);
      if (!accepted) {
        this.setter.setNegativeMarkupAccept(refId, true);
      }
      this.submitOrderRequest(refId);
    }
  }

  public submitBmZeroAmountAccept(refId: string): void {
    if (this.getter.has(refId)) {
      this.setter.setBMZeroAmountAccept(refId, true);
      this.submitOrderRequest(refId);
    }
  }

  public submitTRAcceptTopside(refId: string): Promise<any[]> {
    const remoteAction = (orderIds) => {
      const callOrderRateSide = CubiqTS.RateSideType.BID;
      return this._orderAcceptanceService.requestAcceptance(
        orderIds,
        "",
        CubiqTS.AcceptanceAction.ACCEPT,
        CubiqTS.AcceptanceType.ENTRY,
        null,
        callOrderRateSide,
      );
    };
    return this.executeOrderServerAction("submitTRAcceptTopside", refId, remoteAction);
  }

  public submitTRAcceptDownside(refId: string): Promise<any[]> {
    const remoteAction = (orderIds) => {
      const callOrderRateSide = CubiqTS.RateSideType.OFFER;
      return this._orderAcceptanceService.requestAcceptance(
        orderIds,
        "",
        CubiqTS.AcceptanceAction.ACCEPT,
        CubiqTS.AcceptanceType.ENTRY,
        null,
        callOrderRateSide,
      );
    };
    return this.executeOrderServerAction("TRAcceptDownside", refId, remoteAction);
  }

  public submitModifyOutAccept(refId: string): Promise<any[]> {
    const remoteAction = (orderIds) => {
      return this._orderAcceptanceService.requestAcceptance(
        orderIds,
        "",
        CubiqTS.AcceptanceAction.ACCEPT,
        CubiqTS.AcceptanceType.MODIFICATION,
      );
    };
    return this.executeOrderServerAction("ModifyOutAccept", refId, remoteAction);
  }

  public submitModifyOutReject(refId: string): Promise<any[]> {
    const remoteAction = (orderIds) => {
      return this._orderAcceptanceService.requestAcceptance(
        orderIds,
        "",
        CubiqTS.AcceptanceAction.REJECT,
        CubiqTS.AcceptanceType.MODIFICATION,
      );
    };
    return this.executeOrderServerAction("ModifyOutReject", refId, remoteAction);
  }

  public submitTRAccept(refId: string): Promise<any[]> {
    const remoteAction = (orderIds) => {
      let order: OEDataModel = this.getter.get(refId);
      let orderType: CubiqTS.OrderType = this.utility.convertRequestOrderTypeToOrderType(
        order.orderType.value,
      );

      return this._orderAcceptanceService.requestAcceptance(
        orderIds,
        "",
        CubiqTS.AcceptanceAction.ACCEPT,
        CubiqTS.AcceptanceType.ENTRY,
        null,
        null,
        orderType,
      );
    };
    return this.executeOrderServerAction("TRAccept", refId, remoteAction);
  }

  public submitTRReject(refId: string): Promise<any[]> {
    const remoteAction = (orderIds) => {
      let order: OEDataModel = this.getter.get(refId);
      let orderType: CubiqTS.OrderType = this.utility.convertRequestOrderTypeToOrderType(
        order.orderType.value,
      );

      return this._orderAcceptanceService.requestAcceptance(
        orderIds,
        "",
        CubiqTS.AcceptanceAction.REJECT,
        CubiqTS.AcceptanceType.ENTRY,
        null,
        null,
        orderType,
      );
    };
    return this.executeOrderServerAction("TRReject", refId, remoteAction);
  }

  public submitAbort(refId: string): Promise<any[]> {
    const remoteAction = (orderIds) => {
      let order: OEDataModel = this.getter.get(refId);
      let orderType: CubiqTS.OrderType = this.utility.convertRequestOrderTypeToOrderType(
        order.orderType.value,
      );
      this.setter.setOrderDisplayState(refId, OENDisplayState.SHOW_ABORTING);
      const state = this.getter.getSrvOrderState(refId);
      let orderStateModifyFriendly =
        state === CubiqTS.OrderState.MODIFY_ACCEPTANCE_NEEDED ||
        state === CubiqTS.OrderState.IN_MODIFICATION;
      let acceptanceType: CubiqTS.AcceptanceType =
        this.getter.isOperationModeModify(refId) && orderStateModifyFriendly
          ? CubiqTS.AcceptanceType.MODIFICATION
          : CubiqTS.AcceptanceType.ENTRY;

      return this._orderAcceptanceService.requestAcceptance(
        orderIds,
        "",
        CubiqTS.AcceptanceAction.ABORT,
        acceptanceType,
        null,
        null,
        orderType,
      );
    };
    return this.executeOrderServerAction("Abort", refId, remoteAction);
  }

  public submitUnlockOrdersOnModify(
    orderIds: Array<string>,
    isBmark: boolean = false,
  ): Promise<any> {
    if (isBmark) {
      return this._orderActionService.unlockBenchmarks(orderIds);
    } else {
      return this._orderActionService.modifyOrdersUnlock(orderIds);
    }
  }

  public submitUnlockOrdersFromDI(refId: string): void {
    if (this.getter.has(refId)) {
      let orderId: any = this.getter.getActionableOrderId(refId);
      let orderIds: Array<string> = new Array(
        CubiqTS.Long.isLong(orderId) ? orderId.toString() : orderId,
      );
      // commented out code below will define order type for every unlock request, but it does not seem to be needed (unless bmark)
      //let order: OEDataModel = this.getter.get(refId);
      //let orderType: CubiqTS.OrderType = this.utility.convertRequestOrderTypeToOrderType(order.orderType.value);
      let orderType: CubiqTS.OrderType = this.getter.isBenchmarkRequest(refId)
        ? CubiqTS.OrderType.BENCHMARK
        : null;
      this._orderActionService.releaseOrder(orderIds, orderType).then((response) => {
        //logger.out.warn(`DEV-TEST: _oeWorker.submitUnlockOrdersFromDI(): response: `, response);
      });
    }
  }

  public submitUnlockOrdersOnAmendMarkup(orderIds: Array<string>): void {
    if (Array.isArray(orderIds) && orderIds.length > 0) {
      let refId: string = this.getter.findRefIdForOrderId(orderIds[0]);
      let orderType: CubiqTS.OrderType = null;
      if (typeof refId === "string" && this.getter.isBenchmarkRequest(refId)) {
        orderType = CubiqTS.OrderType.BENCHMARK;
      }
      this._orderActionService.releaseOrder(orderIds, orderType).then((response) => {
        //logger.out.info(`DEV-TEST: _oeWorker.submitUnlockOrdersOnAmendMarkup(): response: `, response);
      });
    }
  }

  /**********************************************************************/
  /* HELPER/UTILITY Methods  */

  public handleErrors(errors: any[]): string {
    let message = "";
    let errorCounter = 1;
    errors
      .map((e) => JSON.parse(e))
      .forEach(
        (e) =>
          (message +=
            (errors.length > 1 ? errorCounter++ + ". " : "") +
            this.translate.instant(e["id"], this.utility.sanityCheckArgs(e["args"])) +
            (errorCounter > 1 && errorCounter <= errors.length ? "<br/>" : "")),
      );
    return message;
  }

  /**
   * Execute the specified action method and return the Promise it generates to the caller.
   *
   * It will return
   * a promise providing the same type as that returned by the input operation
   *
   * @param opName Name of operation for logging
   * @param refId Order reference from which to retrieve the order ID
   * @param remoteAction function instance that takes a list of orderIds and returns a promise
   * @returns
   */
  private executeOrderServerAction<ResultType>(
    opName: string,
    refId: string,
    remoteAction: (orderIds: string[]) => Promise<ResultType>,
  ): Promise<ResultType> {
    let retPromise = null;
    try {
      if (this.getter.has(refId)) {
        let orderId: string = this.getter.getActionableOrderId(refId);
        if (orderId != null) {
          let orderIds: Array<string> = new Array(orderId);
          retPromise = remoteAction(orderIds).then((result) => {
            logger.out.info(`oe-wact - ${opName} complete: result: ${result}`);
            return result;
          });
        } else {
          logger.out.error(`oe-wact - Could not sent ${opName} request, orderID is null!`);
        }
      } else {
        logger.out.error(`oe-wact - Could not sent ${opName} request, model is invalid!`);
      }
    } catch (ex) {
      logger.out.error(`oe-wact - Could not sent${opName} request! ex: %O`, ex);
    }
    if (retPromise === null) {
      retPromise = Promise.resolve([]);
    }
    return retPromise;
  }

  /**********************************************************************/
  /* HELPERS - Debug Log - Extended logging  */

  public setExtendedWorkerLoggingState(logState: boolean): void {
    this._interventionDataService.setExtendedLogging(logState);
    this._orderDataService.setExtendedLogging(logState);
  }

  private outputExtendedLogging(value: string, dump: any = null): void {
    if (dump == null) this.oeLogger.outputDevLogToConsole(value, false);
    else this.oeLogger.outputDevLogToConsole(value, false, dump);
  }
}
